import { NotificationAlertWarningShieldSolidIcon } from '@tableau/icons/NotificationAlertWarningShieldSolidIcon';
import { ButtonType, DialogFooterButtonsWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';

export interface SaveConfirmationDialogBodyProps {
    closeAndDismiss: CloseAndDismiss;
    message: string;
    onSave?: () => Promise<void>;
}

export const IPALLOWLIST_SAVE_CONFIRMATION_CANCEL_BTN_TEST_ID = 'ipallowlist-save-confirmation-cancel';
export const IPALLOWLIST_SAVE_CONFIRMATION_SAVE_BTN_TEST_ID = 'ipallowlist-save-confirmation-save';

interface SaveConfirmationDialogBodyState {
    isSaving: boolean;
}

export class SaveConfirmationDialogBody extends React.Component<SaveConfirmationDialogBodyProps, SaveConfirmationDialogBodyState> {
    constructor(props: SaveConfirmationDialogBodyProps) {
        super(props);
        this.state = {
            isSaving: false
        };
    }

    private getFooterContent = (): React.ReactNode => {
        return (
            <>
                <DialogFooterButtonsWidget
                    buttons={[
                        {
                            handleClick: () => {
                                this.props.closeAndDismiss.close();
                            },
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            testId: IPALLOWLIST_SAVE_CONFIRMATION_CANCEL_BTN_TEST_ID,
                            disabled: this.state.isSaving
                        },
                        {
                            buttonType: ButtonType.Primary,
                            children: Messages.save(),
                            onClick: async () => {
                                this.setState({ isSaving: true });
                                try {
                                    if (this.props.onSave) {
                                        await this.props.onSave();
                                    }
                                    this.props.closeAndDismiss.close();
                                } catch (error) {
                                    // Handle error if needed
                                } finally {
                                    this.setState({ isSaving: false });
                                }
                            },
                            testId: IPALLOWLIST_SAVE_CONFIRMATION_SAVE_BTN_TEST_ID,
                            disabled: this.state.isSaving
                        }
                    ]}
                />
            </>
        );
    };

    public render(): JSX.Element {
        return (
            <div>
                <div style={{ marginBottom: 20 }}>
                    <div style={{ float: 'left', marginRight: 12 }}>
                        <NotificationAlertWarningShieldSolidIcon size={24} />
                    </div>
                    <div>{this.props.message}</div>
                </div>
                <div>
                    {this.getFooterContent()}
                </div>
            </div>
        );
    }
}